<template>
  <div>
    <sn-label
      v-if="label"
      class="mb-2"
      :title="label"
    />
    <v-textarea
      v-bind="vuetifyOverrideMixin.bindings"
      class="sn-textarea"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import SnLabel from '~/components/snui/v2/snLabel/snLabel'
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnTextarea',
  components: { SnLabel },
  mixins: [vuetifyOverrideMixin],
  props: {
    label: { type: String, default: '' }
  },
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          hideDetails: 'auto'
        },
        overriddenProps: {
          backgroundColor: undefined,
          clearable: false,
          color: undefined,
          dark: false,
          dense: false,
          filled: false,
          label: undefined,
          light: false,
          outlined: false,
          persistentHint: true,
          reverse: false,
          rounded: false,
          shaped: false,
          solo: false,
          soloInverted: false,
          successMessages: []
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-textarea {
  @extend .v-text-field--sn_override;
}

.sn-textarea::v-deep {
  textarea::placeholder {
    color: $sn-primary-01 !important;
  }

  .v-input__slot {
    padding: 0px !important;

    .v-text-field__slot {
      height: 100%;

      textarea {
        padding: 11px 16px !important;
      }
    }
  }
}
</style>
